<p-image
  #pImage
  class="hidden"
  alt="Image"
  width="0"
  height="0"
  [preview]="true"
  [appendTo]="'body'" />

<button
  type="button"
  appButton
  [iconPosition]="'only-icon'"
  [color]="'transparent'"
  [icon]="'visibility'"
  [size]="'md'"
  (click)="preview(pImage)"></button>
